import clsx from 'clsx';
import { useFormContext } from 'react-hook-form';

export function Checkbox({ name, label, description, className, ...rest }) {
  const { register, clearErrors } = useFormContext();

  const { onChange, ...field } = register(name);

  return (
    <div className={clsx('px-2.5 py-5 mb-2.5 last:mb-0', className)}>
      <div className="flex items-start gap-3">
        <input
          id={name}
          type="checkbox"
          {...field}
          {...rest}
          onChange={(e) => {
            clearErrors('root');
            onChange(e);
          }}
          className="size-5 mt-0.5 rounded border text-primary cursor-pointer"
        />

        <label className="font-semibold" htmlFor={name}>
          {label}
        </label>
      </div>

      {description && (
        <span className="caption block pt-1.5 px-1 leading-none text-light-500">{description}</span>
      )}
    </div>
  );
}
